import {
  GOOGLE_MAP_URL,
  OfficeAddressKindId,
  SocialLinkKindId,
} from 'Constants/Ids'

export const SOCIAL_LINKS = {
  [SocialLinkKindId.Facebook]: 'https://www.facebook.com/emajingolf',
  [SocialLinkKindId.Instagram]: 'https://www.instagram.com/emajingolf/',
  [SocialLinkKindId.LinkedIn]: 'https://www.linkedin.com/company/emajingolf/',
}

export const CONTACT_PHONE = '1800 362 546'
export const CONTACT_EMAIL = 'clubhouse@emajin.golf'

export const GOOGLE_MAP_LINK = (address: string) => {
  const encodedAddress = encodeURIComponent(address)

  return `${GOOGLE_MAP_URL}${encodedAddress}`
}

export const OFFICE_ADDRESSES = [
  {
    id: OfficeAddressKindId.Sydney,
    city: 'Sydney',
    address: 'Suite 302, 52 Alfred Street S, Milsons Point NSW 2061',
    location: 'Suite 302/52 Alfred St S',
  },
  {
    id: OfficeAddressKindId.Melbourne,
    city: 'Melbourne',
    address: '2/1 Southbank Blvd, Southbank VIC 3006',
    location: '2/1 Southbank Blvd, Southbank VIC 3006',
  },
  {
    id: OfficeAddressKindId.Brisbane,
    city: 'Brisbane',
    address: 'Level 19, 10 Eagle St, Brisbane, Australia',
    location: 'Level 19, 10 Eagle St, Brisbane, Australia',
  },
]
